// İSG uzmanı portalı — Mobil Uygulama sayfası (panel-İÇİ; api-contract §26). NAV'daki
// "Mobil Uygulama" girişinden açılır (D4). İSG Portal yönetici uygulamasının (mobile-manager)
// iOS/Android mağaza linklerini (`GET /app-settings`) gösterir; link boşsa "yakında".
//
// Okuma herhangi authenticated principal'a açıktır (§26.1) — ayrı gate yoktur (panel oturumu
// yeterli). web-supplier `MobileAppPage` ile AYNI desendir.

import { Breadcrumb, Card, CardContent, PageHeader, Spinner } from '@isgportal/shared';
import { useTranslation } from 'react-i18next';
import { AppDownloadLinks } from '../components/AppDownloadLinks';
import { useAppSettings } from '../lib/useAppSettings';

export function MobileAppPage() {
  const { t } = useTranslation();
  const { iosAppUrl, androidAppUrl, isLoading } = useAppSettings();

  return (
    <div className="flex flex-col gap-6">
      <Breadcrumb items={[{ label: t('mobileApp.title') }]} />
      <PageHeader title={t('mobileApp.title')} helperText={t('mobileApp.subtitle')} />

      <Card>
        <CardContent className="flex flex-col gap-4">
          <h2 className="text-sm font-semibold text-fg">{t('appDownload.storesTitle')}</h2>
          {isLoading ? (
            <div className="flex min-h-[6rem] items-center justify-center">
              <Spinner label={t('appDownload.loading')} />
            </div>
          ) : (
            <AppDownloadLinks iosAppUrl={iosAppUrl} androidAppUrl={androidAppUrl} size="lg" />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
